export const identityRoutes = [
  {
    id: 1,
    title: "Dashboard",
    text: "Dashboard",
    path: "/dashboard",
    subNav: [],
  },
  // {
  //   id: 2,
  //   title: "User Management",
  //   path: "/userManagement",
  //   text: "User Management",
  //   subNav: [
      { id: 2.1, path: "/user", text: "User" },
      { id: 2.2, path: "/role", text: "Role" },
      { id: 2.3, path: "/modules", text: "Modules" },
      { id: 2.4, path: "/menu", text: "Menu" },
      { id: 2.5, path: "/feature", text: "Features" },
      { id: 2.6, path: "/featureAccess", text: "Features Access" },
      { id: 2.7, path: "/menuGroup ", text: "Menu Group" },
  //   ],
  // },
];

// css values constants
export const drawerWidth = 220;
export const appBarColor = 'rgb(245,245,245)'
export const drawerColor = 'rgb(240,240,240)'
